import React from 'react';
import styled from 'styled-components';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import ProjectForm from './ProjectForm';
import { ButtonPrimary } from '@yuhu-inc/yuhui';

const ScrollablePanel = styled.div`
  height: 100%;
`;

const FORM_NAME = 'project_edit_form';

const ProjectEditing = ({
  selectedProject,
  properties,
  units,
  fetchUnitsOfProperty,
  putProject,
  fetchProject,
}) => {
  const handleSubmissionComplete = (formData) => {
    fetchProject(formData.id);
  };

  return (
    <ScrollablePanel>
      <Row>
        <Spacer style={{ width: '100%' }} pt={2} pb={2} pr={2} pl={2}>
          <ProjectForm
            formName={FORM_NAME}
            formData={selectedProject}
            properties={properties}
            fetchUnitsOfProperty={fetchUnitsOfProperty}
            units={units}
            onSubmissionComplete={handleSubmissionComplete}
            putProject={putProject}
            disabledPropertySelect
          />
          <Spacer mt={2}>
            <ButtonPrimary
              form={FORM_NAME}
              type="submit"
              style={{ padding: '1px 50px' }}
              contentKey="landlordPortal.maintenance.projects.saveChanges"
            />
          </Spacer>
        </Spacer>
      </Row>
    </ScrollablePanel>
  );
};

export default ProjectEditing;
